// Vendor JS
import Debug from 'debug';

/**
 * Fired on the about us page
 */
export default {
	init() {
		try {
			Debug(`cig:info:sage:route:about`)(`init start`);


		} catch (err) {
			Debug(`cig:error:sage:route:about`)(`About Route init Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	},

	// Fires after init
	finalize() {
		try {
			Debug(`cig:info:sage:route:about`)(`finalize start`);

		} catch (err) {
			Debug(`cig:error:sage:route:about`)(`About Route finalize Error: %s %o`, err.message, err);
			throw new Error(err);
		}
	}
};
